<template>
  <div>
    <div v-if="current && current.reqtrasladolocd_set">
      <div v-if="window.width < 720">
        <div style="z-index: 1000 !important;" class="floated-colors-btn second-floated-btn" @click="cambiarUiTabla">
          <div class="os-toggler-w" :class="{ on: cambiar_UiTabla }">
            <div class="os-toggler-i">
              <div class="os-toggler-pill"></div>
            </div>
          </div>
          <span v-if="!cambiar_UiTabla">Tabla Detalle</span>
          <span v-if="cambiar_UiTabla">Tabla Resumen</span>
        </div>
        <div>
          <div class="col-lg-12">
            <!--START - Projects list-->
            <div v-if="!cambiar_UiTabla" class="projects-list">
              <div class="project-box" v-for="detalle in current.reqtrasladolocd_set" :key="detalle.id"
                style="background-color: beige;">
                <div class="project-head" style="padding-left: 1px; padding: 1px 1px">
                  <br>
                  <div class="project-title">
                    <h5>
                      {{ detalle.producto.sku }}
                    </h5>
                    <small>{{ detalle.producto.nombre }}</small>
                  </div>
                  <div class="badge badge-info form-inline justify-content-sm-end"
                    v-if="detalle.producto && detalle.producto.categoria">
                    {{ detalle.producto.categoria.nombre }}
                  </div>
                  <div class="project-info" style="padding: 10px 1px">
                    <div class="row align-items-center">
                      <div class="col-sm-12">
                        <div class="row">
                          <!--<div class="col-4">
                            <div class="el-tablo highlight">
                              <div class="label">Origen</div>
                              <h6 style="color: black">
                                {{ detalle.posicion_origen }}
                              </h6>
                            </div>
                          </div>
                          <div class="col-4">
                            <div class="el-tablo highlight">
                              <small class="label">Destino</small>
                              <h6 style="color: black">
                                {{ detalle.posicion_destino }}
                              </h6>
                            </div>
                          </div>
                          -->
                          <div class="col-6">
                            <div class="el-tablo highlight">
                              <small class="label">Solicitado</small>
                              <h6 style="color: black">
                                {{ detalle.cantidad }}
                              </h6>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="el-tablo highlight">
                              <div class="label">Pickeado</div>
                              <h6 style="color: DodgerBlue">
                                {{
                                  detalle.cantidad - detalle.cantidad_abierta
                                }}
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <div class="row">
                          <div class="col-6">
                            <div class="el-tablo highlight">
                              <div class="label">Pendiente</div>
                              <h6 style="color: orange">
                                {{ detalle.cantidad_abierta }}
                              </h6>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="el-tablo highlight">
                              <div class="label">Colocado</div>
                              <h6 style="color: green">
                                {{ detalle.cantidad_ingresada }}
                              </h6>
                            </div>
                          </div>
                          <br>
                        </div>
                      </div>
                      <div class="row col-sm-12">
                        <br>
                        <div class="col-3"></div>
                        &nbsp;&nbsp;
                        <div class="el-tablo highlight">
                          <span class="label"> Origen: {{ detalle.posicion_origen }} <i
                              class="fas fa-arrow-alt-circle-right"></i> Destino: {{
                                detalle.posicion_destino }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--END - Projects list-->
            <div class="table-responsive" v-if="cambiar_UiTabla">
              <!-------------------- Tabla de REsultados -------------------->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="det in current.reqtrasladolocd_set" v-bind:key="det.id">
                    <td>
                      <div class="value">
                        <small class="font-weight-bold">{{
                          det.producto.sku
                        }}</small>
                        &nbsp;
                        <div class="badge badge-info" v-if="det.producto.categoria">
                          {{ det.producto.categoria.nombre }}
                        </div>
                      </div>
                      <small>
                        <div class="value">
                          {{ det.producto.nombre }}
                        </div>
                      </small>
                      Pickeada:
                      <span class="sub-value font-weight-bold text-success">
                        {{ det.cantidad - det.cantidad_abierta }}
                        <i v-if="det.cantidad_abierta == 0" class="fas fa-check"></i>
                      </span>
                    </td>
                    <td>
                      Solicitada:
                      <span class="sub-value font-weight-bold" style="color: blue">
                        {{ det.cantidad }}
                      </span>
                      <br />
                      Pendiente:
                      <span class="sub-value font-weight-bold text-success">
                        {{ det.cantidad_abierta }}
                      </span>
                      <br />
                      Colocado:
                      <span class="sub-value font-weight-bold text-success">
                        {{ det.cantidad_ingresada }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div v-if="window.width >= 720">
        <div class="table-responsive">
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Producto</th>
                <th class="text-center">categoría</th>
                <th class="text-right">Cant. Pickeada</th>
                <th class="text-right">Cant. solicitada</th>
                <th class="text-right">Cant. pendiente</th>
                <th class="text-right">Cant. ingresada</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="det in current.reqtrasladolocd_set" v-bind:key="det.id">
                <td>
                  <small class="font-weight-bold">{{ det.producto.sku }}</small>
                  <br />
                  <span class="font-weight-bold">{{
                    det.producto.nombre
                  }}</span>
                </td>
                <td class="text-center">
                  <div class="badge badge-info" v-if="det.producto.categoria">
                    {{ det.producto.categoria.nombre }}
                  </div>
                </td>
                <td class="text-right">
                  {{ det.cantidad - det.cantidad_abierta }}
                </td>
                <td class="text-right">{{ det.cantidad }}</td>
                <td class="text-right">{{ det.cantidad_abierta }}</td>
                <td class="text-right">{{ det.cantidad_ingresada }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div aria-hidden="true" class="onboarding-modal modal fade" id="eliminarDetalle" role="dialog" tabindex="-1">
      <div class="modal-dialog madal-animated modal-centered" role="document">
        <div class="modal-content text-center">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span class="close-label">Cancelar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <div class="text-center">
                <h6>
                  {{ detalle.producto.sku }}
                </h6>
                <h6>
                  {{ detalle.producto.nombre }}
                </h6>
              </div>
              <div class="row">
                <br />
                <button class="btn btn-block btn-md btn-danger" type="button" @click="eliminarDetalle(detalle)">
                  Eliminar Linea
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
export default {
  components: {},
  data() {
    return {
      window: {
        width: 0,
        height: 0,
      },
      cambiar_UiTabla: false,
      detalle: {
        producto: "",
      },
    };
  },
  props: ["current"],
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {},
  mounted() { },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    abrirModalEliminarDetalle(detalle) {
      let self = this;
      $("#eliminarDetalle").modal("show");
      self.detalle = detalle;
    },
    eliminarDetalle() {
      let self = this;
      DynamicService.postAction(
        "inv",
        "transferencia_stock",
        this.current.id,
        "eliminar_detalle",
        {
          id_linea: self.detalle.id,
        }
      )
        .then((response) => {
          self.$emit("refreshCurrent");
          $("#eliminarDetalle").modal("hide");
        })
        .catch((error) => {
          Notifications.alert.error(
            "Eliminar detalle",
            error.response.data.detail
          );
        });
    },
    cambiarUiTabla() {
      let self = this;
      self.cambiar_UiTabla = !self.cambiar_UiTabla;
    },
  },
};
</script>
